import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/gitlab-runner/builds/V_Kx-3ExZ/0/feibi/trailsystem-all/frontend-web/layouts/default.vue").then(m => m.default || m))
}